import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {InputTextarea} from "primereact/inputtextarea";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import {Dropdown} from "primereact/dropdown";

const ContactFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, action, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});

  const countryPrefixes = [
    { label: 'US +1', value: '+1' },
    { label: 'RU +7', value: '+7' },
    { label: 'ZA +27', value: '+27' },
    { label: 'GR +30', value: '+30' },
    { label: 'BE +32', value: '+32' },
    { label: 'FR +33', value: '+33' },
    { label: 'ES +34', value: '+34' },
    { label: 'HU +36', value: '+36' },
    { label: 'IT +39', value: '+39' },
    { label: 'RO +40', value: '+40' },
    { label: 'CH +41', value: '+41' },
    { label: 'AT +43', value: '+43' },
    { label: 'GB +44', value: '+44' },
    { label: 'DK +45', value: '+45' },
    { label: 'SE +46', value: '+46' },
    { label: 'NO +47', value: '+47' },
    { label: 'PL +48', value: '+48' },
    { label: 'DE +49', value: '+49' },
    { label: 'MX +52', value: '+52' },
    { label: 'AR +54', value: '+54' },
    { label: 'BR +55', value: '+55' },
    { label: 'CL +56', value: '+56' },
    { label: 'CO +57', value: '+57' },
    { label: 'MY +60', value: '+60' },
    { label: 'AU +61', value: '+61' },
    { label: 'ID +62', value: '+62' },
    { label: 'PH +63', value: '+63' },
    { label: 'NZ +64', value: '+64' },
    { label: 'TH +66', value: '+66' },
    { label: 'JP +81', value: '+81' },
    { label: 'KR +82', value: '+82' },
    { label: 'VN +84', value: '+84' },
    { label: 'CN +86', value: '+86' },
    { label: 'TR +90', value: '+90' },
    { label: 'IN +91', value: '+91' },
    { label: 'PK +92', value: '+92' },
    { label: 'SS +211', value: '+211' },
    { label: 'DZ +213', value: '+213' },
    { label: 'TN +216', value: '+216' },
    { label: 'RW +250', value: '+250' },
    { label: 'IE +353', value: '+353' },
    { label: 'AL +355', value: '+355' },
    { label: 'CY +357', value: '+357' },
    { label: 'FI +358', value: '+358' },
    { label: 'LT +370', value: '+370' },
    { label: 'LV +371', value: '+371' },
    { label: 'EE +372', value: '+372' },
    { label: 'MD +373', value: '+373' },
    { label: 'BY +375', value: '+375' },
    { label: 'UA +380', value: '+380' },
    { label: 'RS +381', value: '+381' },
    { label: 'HR +385', value: '+385' },
    { label: 'SI +386', value: '+386' },
    { label: 'MK +389', value: '+389' },
    { label: 'CZ +420', value: '+420' },
    { label: 'SK +421', value: '+421' },
    { label: 'UY +598', value: '+598' },
    { label: 'HK +852', value: '+852' },
    { label: 'TW +886', value: '+886' },
    { label: 'SA +966', value: '+966' },
    { label: 'AE +971', value: '+971' },
    { label: 'IL +972', value: '+972' }
  ];
  const [phoneCountryCode, setPhoneCountryCode] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState('');

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    const payload = {
      ...formData,
      ...newFormData,
      phone: buildPhoneValue()
    };
    delete payload.phone_country_code;
    if ((window.App.urlVars().contactId) || (entity === 'contact' && id)) {
      apiCall('patch', '/api/v2/contact/' + (window.App.urlVars().contactId ?? id), payload)
        .then(response => {
          window.App.toastShow('success', t('toastSaveSuccess'));
          window.App.setState({rerenderContactpartnerList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      const createPayload = props.partnerId ? {
        ...payload,
        partner: Number(props.partnerId),
      } : payload;
      apiCall('post', '/api/v2/contact', createPayload)
        .then(response => {
          window.App.toastShow('success', t('toastSaveSuccess'));
          window.App.setState({rerenderContactpartnerList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/partner/read/' + id + '/contact/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const parsePhoneValue = (phone) => {
    const raw = (phone || '').toString().trim();
    if (!raw) {
      return {
        countryCode: null,
        number: ''
      };
    }
    const sortedPrefixes = [...countryPrefixes].sort((a, b) => b.value.length - a.value.length);
    const foundPrefix = sortedPrefixes.find(prefix =>
      raw === prefix.value || raw.startsWith(prefix.value + ' ') || raw.startsWith(prefix.value)
    );
    if (!foundPrefix) {
      return {
        countryCode: null,
        number: raw
      };
    }
    return {
      countryCode: foundPrefix.value,
      number: raw.substring(foundPrefix.value.length).trim()
    };
  };

  const buildPhoneValue = () => {
    const prefix = phoneCountryCode || '';
    const number = (phoneNumber || '').toString().trim();
    return [prefix, number].filter(Boolean).join(' ');
  };
  
  useEffect(() => {
    if ((!window.App.urlVars().create && window.App.urlVars().contactId) || (entity === 'contact' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/contact/' + (window.App.urlVars().contactId ?? id))
        .then(response => {
          const contact = response.data.data;
          const parsedPhone = parsePhoneValue(response.data.data.phone);
          setPhoneCountryCode(parsedPhone.countryCode);
          setPhoneNumber(parsedPhone.number);
          setFormData({
            ...contact,
            position: contact.contact_partners?.[0]?.position || ''
          });
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"contact-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldContactName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            {(!!window.App.urlVars().create || action === 'create') && (
            <div className={"p-col-12 p-lg-6"}>
              <Field name="position" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="position"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPosition')}</label>
                  <span className="p-d-block">
                      <InputText id="position" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     position: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     position: e.target.value
                                   })
                                 }}
                                 value={formData.position}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            )}
            <div className={"p-col-12 p-lg-5"}>
              <Field name="email" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="email"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldEmail')}</label>
                  <span className="p-d-block">
                      <InputText id="email" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     email: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     email: e.target.value
                                   })
                                 }}
                                 value={formData.email}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className="p-col-12 p-lg-3">
              <Field name="phone_country_code" render={({ input, meta }) => (
                  <div className="p-field p-fluid">
                      <label htmlFor="phone_country_code" className={classNames({ 'p-error': isFormFieldValid(meta) })}>{props.t('fieldPhoneCountryCode')}</label>
                      <span className="p-d-block">
                          <Dropdown
                            id="phone_country_code"
                            value={phoneCountryCode}
                            options={countryPrefixes}
                            onChange={(e) => {
                              setPhoneCountryCode(e.value);
                              setFormData({
                                ...formData,
                                phone: [e.value, phoneNumber].filter(Boolean).join(' ')
                              });
                            }}
                            filter
                            showClear
                            placeholder={t('selectPlaceholder')}
                            className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                          />
                      </span>
                      {getFormErrorMessage(meta)}
                  </div>
              )} />
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="phone" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="phone"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPhone')}</label>
                  <span className="p-d-block">
                      <InputText id="phone" {...input}
                                  onChange={(e) => {
                                  setPhoneNumber(e.target.value);
                                    setFormData({
                                      ...formData,
                                      phone: [phoneCountryCode, e.target.value].filter(Boolean).join(' ')
                                    })
                                  }}
                                  value={phoneNumber}
                                  className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12"}>
              <Field name="note" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="note"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldNote')}</label>
                  <span className="p-d-block">
                      <InputTextarea id="note" {...input}
                                     rows={4}
                                     onChange={(e) => {
                                       setFormData({
                                         ...formData,
                                         note: e.target.value
                                       })
                                       setNewFormData({
                                         ...newFormData,
                                         note: e.target.value
                                       })
                                     }}
                                     value={formData.note}
                                     className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'contact' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(ContactFormComponent);
